<template>
    <my-dialog ref="dialog" title="我的邀请码">
        <el-card shadow="hover" align="left">
            <div v-if="!isEmailActiviated && loaded" class="row">
                你的邮箱还未激活，邀请码必须在激活邮箱后才能获得，<my-link @click.native="toActivaiteEmail">点击激活</my-link>邮箱！
            </div>
            <div v-else-if="isEmailActiviated && loaded">
                <template v-if="!noSignalVisible">
                    <div align="center">
                        <div>你的邀请码是</div>
                        <div style="display:block;">
                            <input id="inviteCode" size="9" class="invitecode" readonly :value="inviteCode.shortcode" style="position: fixed; top:-1000px; left:-1000px"/>
                            <div class="invitecode">{{inviteCode.shortcode}}</div>
                        </div>
                        <div><my-link @click.native="copy(inviteCode.shortcode)">点击复制</my-link>邀请码</div>
                        <div style="margin: 4px 0 0 0;" class="font-gray">（邀请码有效期至 <span class="font-black">{{inviteCode.valid_to}}</span>）</div>
                    </div>
                    <my-divider :margin="20"></my-divider>
                    <div align="left">
                        <p><i class="el-icon-info"></i><span style="margin-left:4px">邀请码使用规则：</span></p>
                        <ul>
                            <li>被邀请人使用你的邀请码注册并激活邮箱后可获赠 {{inviteCode.invitee_reward_points}} 积分</li>
                            <li>同时你可获赠 {{inviteCode.inviter_reward_points}} 积分</li>
                        </ul>
                    </div>
                </template>
                <template v-else>
                    <div align="center">
                    <no-signal
                        ref="noSignal"
                        display-mode="vertical"
                        :retry-handlers="[loadInviteCode_]"
                        :retry-basis="false"
                        :margin-top="35"></no-signal>
                    </div>
                </template>
            </div>
        </el-card>
    </my-dialog>
</template>

<script>
    import MyDialog from "../../commons/MyDialog";
    import {loadInviteCode, loadInviteCodeTrace} from "../../../data/user";
    import {successMessage, DateFormat, isPhoneAgent, GlobalLoading, errorMessage, HTML} from "../../../utils";
    import { TimeoutError, NetworkError } from '@shangyang/error';

    export default {
        name: "UserInviteCode",
        components: {MyDialog},
        data(){
            return {
                loaded: false,
                tableData: [],
                inviteCode: {
                    type: Object,
                    default: null
                },
                noSignalVisible: false
            }
        },
        computed: {
            isEmailActiviated() {
                return this.$store.state.user !== null ? this.$store.state.user.is_email_activated: false
            }
        },
        methods: {
            async show(){
                this.reset();
                // 延时显示
                setTimeout(()=>{
                    this.$refs.dialog.show();
                }, 300);
                GlobalLoading.start();
                try{
                    let user = this.$store.getters.getUser();
                    if (user.inviteCode !== undefined && user.inviteCode !== null){
                        this.inviteCode = user.inviteCode;
                    } else if (user.is_email_activated){  // 这里这么判断是安全的，因为一旦激活后将会 reload $store.state.user
                        console.log('the email is activated');
                        await this.loadInviteCode_();
                    }
                    this.loaded = true;
                }catch(error){
                    console.error(error);
                    throw error;
                }finally{
                    GlobalLoading.stop();
                }
            },
            reset(){
                this.loaded = false
                this.tableData = []
                this.inviteCode = null // 8 位占位符
                this.noSignalVisible = false;
            },
            async loadInviteCode_(){
                try {
                    this.inviteCode = await loadInviteCode.bind(this)();
                    this.noSignalVisible = false;
                } catch (error){
                    console.error(error);
                    // 如果是第一页就出现了网络异常，将其切换成 main page 异常。
                    if (error instanceof TimeoutError || error instanceof NetworkError) {
                        errorMessage(error.message);
                        this.noSignalVisible = true; // 显示 no signal comp
                    }
                    throw error; // 必须抛出这个异常，否则 List 的 nextPage 调用该句柄的时候会认为是正常返回导致异常
                }
            },
            toActivaiteEmail(){
                console.log('to activate email');
                this.$refs.dialog.hide();
                this.$parent.$parent.$refs.userActiviateEmail.show();
            },
            /**
             * 参考 https://www.w3schools.com/howto/howto_js_copy_clipboard.asp
             * @deprecated 这种方式必须从 input 元素中选中要赋值的内容，然后执行 copy 指令。不太灵活，特别是很多时候并不需要 input 元素。
             */
            copy(){
                HTML.copy('inviteCode');
                successMessage('复制成功');
            },
            /**
             * 通过 Async Clipboard API 完成拷贝，不需要 input 元素
             * 参考 https://stackoverflow.com/questions/400212/how-do-i-copy-to-the-clipboard-in-javascript
             * 很可惜，这种方式在 Hybrib app 上不被支持
             * @param shortcode
             */
            __copy(shortcode){
                console.log('execute copy() with', shortcode);
                if (navigator.clipboard !== undefined){
                    navigator.clipboard.writeText(shortcode).then(function() {
                        console.log('Async: Copying to clipboard was successful!');
                        successMessage('复制成功');
                    }, function(err) {
                        console.error('Async: Could not copy text: ', err);
                        errorMessage('复制失败');
                    });
                } else{
                    this.__copy();
                }
            }
        }
    }
</script>

<style scoped>

    /* 靠，element-ui 的 el-table 默认使用的是 position:relative 导致 PC 端下拉刷新获取最新页面的时候不回弹，结果一股脑全部加载完所有分页 */
    /deep/ .el-table{
        position: unset !important;
    }

    /deep/ .dialog-content-panel {
        height: 300px;
    }

    .row{
        height: 40px;
        display: block;
    }

    .invitecode{
        font-weight: 600;
        font-size:20px;
        color: #CB0101;
        margin: 4px 0 4px 0;
        border: 0px;
        /*width: 100%;*/
    }

    /* medium phone screen */
    @media (min-width: 350px) and (max-width: 540px) {
        /deep/ .el-card__body {
            padding: 20px !important;
        }
    }

    /* small phone screen */
    @media (max-width: 350px) {
        /deep/ .el-card__body {
            padding: 20px !important;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/user/center/UserInviteCode.vue